import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import store from './store'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'

import config from './core/config'
import moment from 'moment';
import 'moment/locale/fr'
import 'moment/locale/nl'
import { createI18n } from './i18n'
import http from './core/http'
import auth from './core/auth'
import api from './core/api'
import VueChartkick from 'vue-chartkick'
// import VueSocketio from 'vue-socket.io-extended';
// import SocketIo from "socket.io-client"
import fullCalendar from 'vue-full-calendar';
import {Timeline} from '@/components/vue2vis';
import Layout from './pages/layout'
import JsonCSV from 'vue-json-csv';
import vueKanban from 'vue-kanban';
import VueGoogleCharts from 'vue-google-charts'
import DatetimePicker from '@/components/common/DatetimePicker'
import MApp from '@/mixins/app'

import 'vis/dist/vis.min.css';
import "fullcalendar/dist/fullcalendar.css";
import "./assets/css/style.css";


Vue.filter("date", date => moment(date).format('DD/MM/YYYY'));
Vue.filter("datetime", date => moment(date).format('DD/MM/YYYY HH:mm'));

Vue.filter('currency', (value, zero, skip) => {
  if (value !== 0 && value !== '' && !isNaN(value)) {
    return parseFloat(value).toFixed(2) + (skip ?  '': ' €')
  } else {
    if (value === 0 && zero) {
      return value + ' €'
    } else {
      return ''
    }
  }
});
Vue.filter('formatTime', time => {
  if (time) {
    var t = time.split(':');
    if (t.length > 1) {
      time = t[0] + ':' + t[1] + 'h';
    }
    return time;
  }
});

Vue.config.productionTip = false
Vue.component('m-layout', Layout);
Vue.use(fullCalendar);
Vue.component('m-layout', Layout);
Vue.component('m-timeline', Timeline);
Vue.component('downloadCsv', JsonCSV);
Vue.component('v-datetime-picker', DatetimePicker);

// const socket = SocketIo(config.ioURL, {
//   autoConnect: false,
//   withCredentials: false
// });

//Vue.use(VueSocketio, socket, { store });

var i18n = createI18n()
// http.instance();
window.http = http.instance();
window.api = api;
Vue.prototype.$auth = auth;
window.initMap = async function () {
  window.google = await google;
}

Vue.use(vueKanban)
Vue.use(VueChartkick)
Vue.use(VueGoogleCharts);

const EventBus = new Vue()

Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  },
  $moment: {
    get: function () {
      return moment
    }
  }
})

var vue = new Vue({
  mixins : [MApp],
  i18n,
  router,
  store,
  vuetify,
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  render: h => h(App, )
}).$mount('#app')

window.vue = vue;
